const workspaceModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/workspace-modal.html',
  controller: 'WorkspaceModalController',
};

angular
  .module('pis-tool.module')
  .component('workspaceModal', workspaceModal);
